import { render, staticRenderFns } from "./myTask_detail.vue?vue&type=template&id=8caf95b4&scoped=true"
import script from "./myTask_detail.vue?vue&type=script&lang=js"
export * from "./myTask_detail.vue?vue&type=script&lang=js"
import style0 from "./myTask_detail.vue?vue&type=style&index=0&id=8caf95b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8caf95b4",
  null
  
)

export default component.exports